import { AUTH_ERROR_CODES } from '@root/src/constants/Default'
import { auth } from '@root/firebaseDatabase'
import store from '../store/index'
import { showDanger, showSuccess } from './AlertService'
import { signInWithEmailAndPassword } from 'firebase/auth'
import { readData } from '@utils/DataService'

const AUTH_CODES = {
	'auth/wrong-password': 'The password is incorrect!',
	'auth/user-not-found': 'User does not exist!'
}

export const fetchAuthState = () => {
	return new Promise((resolve, reject) => {
		auth.onAuthStateChanged(async (res) => {
			if (res?.uid) {
				await store.dispatch('updateCurrentUser', res)

				// Wait for tenant to be initialized in store
				const waitForTenant = () => {
					if (store.state.tenant) {
						const unsubscribe = readData({
							ref: `tenant/${res.tenantId}/users/${store.state.userOverride || res.uid}`,
							listen: true,
							onUpdate: (user) => {
								if (!user?.data) {
									return console.error('unable to locate user document')
								}
								store.dispatch('updateUser', user)
								const snapshots = store.state.unsubscribe
								snapshots.push(unsubscribe)
								store.commit('setUnsubscribe', snapshots)
								resolve(user.data)
							}
						})
					} else {
						setTimeout(waitForTenant, 100)
					}
				}

				waitForTenant()
			} else {
				const { unsubscribe } = store.state
				if (typeof unsubscribe !== 'undefined') {
					unsubscribe.forEach((snapshot) => snapshot())
					store.commit('setUnsubscribe', [])
				}
				await store.dispatch('updateViewAs', null)
				await store.dispatch('updateCurrentUser', null)
				await store.dispatch('updateUser', null)
				reject()
			}
		})
	})
}

export const loginWithEmailAndPassword = (email, password, tenantId) => {
	return new Promise((resolve, reject) => {
		auth.tenantId = tenantId
		signInWithEmailAndPassword(auth, email, password)
			.then((userCredential) => {
				store.dispatch('updateCurrentUser', userCredential.user)
				showSuccess('User successfully logged in!', 2000)
				resolve(userCredential.user)
			})
			.catch((error) => {
				showDanger(AUTH_CODES[error.code] || AUTH_ERROR_CODES[error.code] || error.message, 5000)
				reject(error)
			})
	})
}
